import { OrganizationModel } from 'shared/domain/organization/types/model';
import {
  isBelowSuperAdminPermission,
  UserPermissionDto,
  UserRole,
} from 'shared/types/userRole';

/**
 * Organization IDs where user has organizationAdmin in basePermissions.
 * Empty for super admin (handled separately via role check).
 */
export function getOrganizationAdminOrganizationIds(
  basePermissions: UserPermissionDto
): Set<string> {
  const result = new Set<string>();
  if (!isBelowSuperAdminPermission(basePermissions)) {
    return result;
  }
  basePermissions.clients?.forEach((client) => {
    if (client.role === UserRole.organizationAdmin) {
      result.add(client._id);
    }
  });
  return result;
}

export function getClientAdminPermission(
  basePermissions: UserPermissionDto,
  organizations: Map<string, OrganizationModel>
): Map<string, boolean> {
  const permissionsMap = new Map<string, boolean>();

  if (basePermissions.role === UserRole.superAdmin) {
    organizations.forEach((organization) =>
      permissionsMap.set(organization._id, true)
    );
    return permissionsMap;
  }

  getOrganizationAdminOrganizationIds(basePermissions).forEach((orgId) => {
    permissionsMap.set(orgId, true);
  });

  return permissionsMap;
}
